import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { rem } from 'polished';
import {
  animations,
  colors,
  text,
  shadows,
  mixins,
  spaces,
} from '../../../core/styles/theme/default';
import { LinkContent } from '../partials';
import { LinkProps } from '../Link';

const StyledLink = styled(LinkContent)(
  ({ isSmall, withTopIcon }: any) => css`
    display: flex;
    justify-content: space-between;
    padding: ${rem(24)};
    border-radius: ${rem(4)};
    border: ${rem(1)} solid ${colors.grue300};
    ${text.c1};
    color: ${colors.primary};
    transition: all ${animations.default};
    transition-property: box-shadow;
    background-color: ${colors.white};

    ${isSmall &&
    css`
      padding: ${rem(9)} ${rem(24)} ${rem(9)} ${rem(14)};
      line-height: ${rem(20)};
      text-decoration: none;
    `}

    ${withTopIcon &&
    css`
      justify-content: flex-start;
      position: relative;
      padding-top: ${rem(92)};

      ${mixins.MQMax('medium')} {
        flex-grow: 1;
        justify-content: space-between;
        padding: ${rem(64)} ${rem(spaces.delta)} ${rem(spaces.gamma)}
          ${rem(spaces.gamma)};
        font-size: ${rem(16)};
      }

      ${mixins.MQMax('small')} {
        padding: ${rem(spaces.gamma)} ${rem(spaces.delta)} ${rem(spaces.gamma)}
          ${rem(spaces.gamma)};
      }
    `}

    &:hover,
    &:focus {
      box-shadow: ${shadows.dropDownHover};
    }

    &:active {
      background-color: ${colors.nightBlue100};
    }

    &.active {
      .label {
        text-decoration: underline;
      }
    }

    .label::after {
      content: none !important;
    }

    > svg {
      ${isSmall && css``}

      ${withTopIcon &&
      css`
        &:first-of-type {
          position: absolute;
          top: ${rem(spaces.delta)};
          left: ${rem(spaces.delta)};
          width: 32px;
          height: 32px;
          margin-left: 0;

          ${mixins.MQMax('medium')} {
            top: ${rem(spaces.gamma)};
            left: ${rem(spaces.gamma)};
          }

          ${mixins.MQMax('small')} {
            display: none;
          }
        }
      `}
    }
  `,
);

const LinkEmphasized = ({ iconAfter = 'EchIconRight', ...rest }: LinkProps) => {
  return <StyledLink iconAfter={iconAfter} {...rest} />;
};

export default LinkEmphasized;
